import { progressiveComponent } from 'site-modules/shared/components/progressive-component/progressive-component';

export default {
  USMap: progressiveComponent({
    fullComponent: {
      loader: () => import(/* webpackChunkName: "us-map" */ 'site-modules/shared/components/us-map/us-map'),
      name: 'USMap',
    },
  }),
};
